import React, { useState } from "react";
import {
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Snackbar,
  Alert,
} from "@mui/material";
import { upsertShippingSettings } from "../../../../services/vendor/vendor.service";

const CubeRateTable = ({ initialData, setCubeRate }) => {
  //   console.log("CubeData", initialData);
  const [data, setData] = useState(initialData);
  // 🟢 Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleInputChange = (e, index, field) => {
    const newData = [...data];
    newData[index][field] = e.target.value;
    setData(newData);
  };

  const handleSave = async () => {
    try {
      const payload = {
        cubeRates: data.map((row) => ({
          state: row.state,
          cubeRate: Number(row.cubeRate),
          minimumRate: Number(row.minimumRate),
        })),
      };

      //   console.log("Sending cubeRates payload:", payload);

      const res = await upsertShippingSettings(payload);
      //   console.log("resss",res)
      if (res?.data) {
        setData(res?.data?.cubeRates);
      }
      // 🟢 Show success message
      setSnackbar({
        open: true,
        message: res?.message || "Cube rate table saved successfully!",
        severity: "success",
      });

      setCubeRate(false)
    } catch (error) {
      setSnackbar({
        open: true,
        message: "Failed to save cube rates.",
        severity: "error",
      });
    }
  };

  return (
    <Box sx={{ width: "100%", fontFamily: "sans-serif", pb: 2 }}>
      {/* 🔔 Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          display: "flex",
          position: "sticky",
          top: 0,
          p: 2,
          zIndex: 999,
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "#f0f0f0",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }}
      >
        <Typography variant="body1" fontWeight="bold">
          Cube Rate & Minimum Rate Table
        </Typography>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#17a858",
            color: "white",
            fontWeight: "bold",
            borderRadius: "50px",
            width: "30%",
            "&:hover": {
              backgroundColor: "#17a858",
            },
          }}
          onClick={handleSave}
        >
          save
        </Button>
      </Box>

      <TableContainer
        component={Paper}
        sx={{ borderRadius: 0, mt: 1, maxHeight: "100%", overflowY: "auto" }}
      >
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold" }}>
                Distribution Center State
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Cube Rate
              </TableCell>
              <TableCell align="center" sx={{ fontWeight: "bold" }}>
                Minimum Rate
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow
                key={row.state}
                sx={{
                  backgroundColor: index % 2 === 0 ? "#f0f0f0" : "#f0f0f0",
                }}
              >
                <TableCell component="th" scope="row">
                  {row.state}
                </TableCell>
                <TableCell align="center">
                  <TextField
                    variant="standard"
                    placeholder="enter"
                    value={row.cubeRate}
                    onChange={(e) => {
                      const val = e.target.value;
                      // ✅ Only numbers + single decimal point
                      if (/^\d*\.?\d*$/.test(val)) {
                        handleInputChange(e, index, "cubeRate");
                      }
                    }}
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-input": { p: 0 },
                    }}
                  />
                </TableCell>
                <TableCell align="center">
                  <TextField
                    variant="standard"
                    placeholder="enter"
                    value={row.minimumRate}
                    onChange={(e) => {
                      const val = e.target.value;
                      // ✅ Only numbers + single decimal point
                      if (/^\d*\.?\d*$/.test(val)) {
                        handleInputChange(e, index, "minimumRate");
                      }
                    }}
                    inputProps={{ style: { textAlign: "center" } }}
                    InputProps={{ disableUnderline: true }}
                    sx={{
                      "& .MuiInput-input": { p: 0 },
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default CubeRateTable;
